import func from '../common/function';
import si from '../data/snapshot-info';
import sd from '../data/snapshot-data';
import sr from './snapshot-restore';
import sdel from './snapshot-delete';

let snapshot = {
  bindSnapshot : ()=>{
    si.snapshots();
    snapshot.bindLists();
  },
  bindLists :()=>{
    let $lists = $('table.ui-snapshot-list');
    if(!$lists.length){
      $lists = $(`<table class="ui-snapshot-list"></table>`);
      $('main').append($lists);
    }else{
      $lists.html('');
    }
    sd.snapshots.forEach((t,i)=>{
      let $row = $('<tr></tr>');
      $row.append(`<td><a class="btn btn-delete btnRemove" data-index="${i}">&times;</a></td></td>`);
      $row.append(`<td>${t.snapshot}</td>`);
      $row.append(`<td><span class="subscr">created at</span> ${func.convertDate(t.start_time)}</td>`);
      $row.append(`<td>${t.indices.length} <span class="subscr">indices</span></td>`);
      $row.append(`<td><a class="btn btnRestore" data-index="${i}">restore</a>`);
      $lists.append($row);
    });
    $('.btnRestore').click(e=>{
      sr.restore(sd.snapshots[$(e.target).data('index')], e.target);
    });
    $('.btnRemove').click(e=>{
      sdel.exeDelete(sd.snapshots[$(e.target).data('index')]);
    });
    return snapshot;
  }
}

export default snapshot;


// WEBPACK FOOTER //
// ./src/scripts/ui/snapshot.js